import * as React from 'react';
import classNames from 'classnames';
import { ColumnWidth, ScreenSize } from '../theme';

export type ColumnProps = Partial<Record<Exclude<ScreenSize, 'xl'>, ColumnWidth>> &
    Pick<React.HTMLAttributes<HTMLDivElement>, 'className' | 'style'> &
    {
        children?: React.ReactNode;
    };

export const Column: React.FC<ColumnProps> = ({
    children,
    className,
    lg = '',
    md = '',
    sm = '',
    xs = '',
    ...props
}) => (
    <div
        className={classNames({
            [`col-xs-${xs}`]: xs,
            [`col-sm-${sm}`]: sm,
            [`col-md-${md}`]: md,
            [`col-lg-${lg}`]: lg,
        })}
        {...props}
    >
        {children}
    </div>
);
